"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncTimes = exports.times = void 0;
/**
 * Repeat the given function `number` times
 *
 * @param number The number of times to itterate
 * @param cb The function to run
 */
exports.times = (number, cb) => {
    const result = [];
    for (let i = 1; i <= number; i++) {
        result.push(cb(i));
    }
    return result;
};
/**
 * Repeat the given function `number` times asyncronously
 *
 * @param number The number of times to itterate
 * @param cb The function to run
 */
exports.asyncTimes = (number, cb) => __awaiter(void 0, void 0, void 0, function* () {
    const result = [];
    for (let i = 1; i <= number; i++) {
        result.push(yield cb(i));
    }
    return result;
});
//# sourceMappingURL=times.js.map